import { render, staticRenderFns } from "./AddProcessor.vue?vue&type=template&id=533ac12a&scoped=true&"
import script from "./AddProcessor.vue?vue&type=script&lang=ts&"
export * from "./AddProcessor.vue?vue&type=script&lang=ts&"
import style0 from "./AddProcessor.vue?vue&type=style&index=0&id=533ac12a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ac12a",
  null
  
)

export default component.exports